<template>
  <div class="progress-bar-parent bg-white p-4">
      <table>
          <tbody>
              <tr v-for="item in chartData" :key="item.branch_code" class="mt-4">
                  <td class="branch-title">
                      {{ item.branch_name }}
                  </td>
                  <td class="w-full bar-cell">
                      <div class="progress h-full relative overflow-hidden">
                          <div class="progress-bar h-full absolute" role="progressbar" :style="{ width: Math.round(item.average_delivery_duration / allTime * 100) + '%'}" :aria-valuenow="item.average_delivery_duration" aria-valuemin="0" aria-valuemax="100"></div>
                          <div class="dashes absolute "></div>
                          <span class="percentage-text">{{ ((item.average_delivery_duration / allTime) * 100).toFixed(2) }}</span>
                      </div>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    limit: {
      type: Number,
      default: null,
    },
    dateFrom: {
      type: String,
      default: null,
    },
    dateTo: {
      type: String,
      default: null,
    },  
  },
  data() {
    return {
      chartData: [],
      chart: null,
      allTime: 0
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
      async fetchData() {
          try {
              const params = new URLSearchParams();
              
              if (this.limit !== null && Number.isInteger(this.limit)) {
                  params.append('limit', this.limit);
              }
              
              if (this.dateFrom) {
                  params.append('date_from', this.dateFrom);
              }
              
              if (this.dateTo) {
                  params.append('date_to', this.dateTo);
              }

              const response = await axios.get(
                  `${process.env.VUE_APP_BASE_URL}order/delivery_percentage?${params}`
              );

              this.chartData = response.data.data;
              this.allTime = this.chartData.reduce((total, item) => total + +item.average_delivery_duration, 0);

            } catch (error) {
              console.error('Error fetching data:', error);
          }
      },


  },
};
</script>

<style scoped>
  tr{
      height: 33px;
      & td , & div{
          height: 17px;
          max-height: 17px;
      }
      & div.dashes{
          height: 0px;
      }
    }
  .branch-title{
    min-width: 75px;
    font-weight: 500;
    font-size:11px;
  }
  .bar-cell  {
    height: 17px;;
    max-height: 17px;;
  }
  .dashes{
    top: 50%;
    translate: 0 -50%;
    border: 1px dashed rgba(0, 0, 0, 0.2);
    width: 100%;
    z-index: 1;
  }
  .progress-bar{
    background-color: rgba(49, 0, 111, 1) ;
    z-index: 2;
  }

  .percentage-text{
    position: absolute;
    width: 30px;
    min-width: fit-content;
    text-align: center;
    top: 50%;
    right: 0;
    translate: 0% -50%;
    z-index: 3;
    font-size: 12px;
    background-color: rgba(49, 0, 111, 1);
    color: #fff;
    font-weight: 700;
    border-radius: 5px;
    padding-inline: 8px;
  }

</style>